// Directives are loaded in the plugins/custom-directives.ts file
// Not to be imported/used in components.

import type { RegisterCustomDirective } from 'src/plugins/custom-directives'
import { passwordManagerIgnore } from './password-manager-ignore'

export const directives: RegisterCustomDirective[] = [
  passwordManagerIgnore
]
